import { cn } from "@/ds/utils";
import { collectionArts } from "@/lib/media/collectionArts";
import type { FC } from "react";

export interface CollectionImageProps {
	image: number;
	className?: string;
}

export const CollectionImage: FC<CollectionImageProps> = props => {
	const {
		image,
		className
	} = props;

	const collectionArt = collectionArts[image];

	return (
		<div
			style={{ backgroundImage: `url(${collectionArt})` }}
			className={cn("w-12 rounded-[5%] aspect-402/331 bg-background bg-contain bg-center bg-no-repeat", className)}></div>
	);
};
